<template>
    <router-view></router-view>
</template>
<script>
    
    export default {
        created(){
            window.countryCODE = this.$route.params.country.toLowerCase();
            //falta checkear si operamos alli
        }
    }
</script>


// WEBPACK FOOTER //
// Prefix.vue?ac529532